// Incremental KeyValues projection. Discard irrelevant values while tokenizing;
// never materialize the full 8+ MiB string, token array, or economy schema tree.
const groups = new Set(['prefabs','items','attribute_controlled_attached_particles','rarities','colors']);
const itemFields = new Set(['item_name','name','item_quality','item_rarity','hidden','prefab','particle_suffix','item_class','item_slot','static_attrs','attributes','visuals','visuals_red','visuals_blu','visuals_mvm_boss','taunt']);
const visuals = new Set(['use_visualsblock_as_base','attached_particles','attached_particlesystems','custom_particlesystem','custom_particlesystem2','tracer_effect','muzzle_flash','custom_color','custom_color1','custom_color2','player_bodygroups','styles','wm_bodygroup_override','wm_bodygroup_state_override']);
const tauntFields = new Set(['particle_attachment','custom_taunt_prop_per_class','custom_taunt_prop_scene_per_class']);
function retain(path) {
    if (path.length <= 1) return !path.length || path[0] === 'items_game';
    if (!groups.has(path[1])) return false;
    if (['attribute_controlled_attached_particles','rarities','colors'].includes(path[1]) || path.length <= 3) return true;
    if (!itemFields.has(path[3]) && path[3] !== 'hide_bodygroups_deployed_only') return false;
    if (path[4] === 'styles' && path.length >= 7) return ['additional_hidden_bodygroups','bodygroup'].includes(path[6]);
    if (path[3].startsWith('visuals') && path.length >= 5) return visuals.has(path[4]);
    if (path[3] === 'taunt' && path.length >= 5) return tauntFields.has(path[4]);
    if (path[3] === 'attributes' && path.length >= 6) return path[5] === 'value';
    return true;
}
export class ItemSchemaStream {
    constructor() { this.root=Object.create(null); this.stack=[{ path:[],object:this.root,key:null }]; this.decoder=new TextDecoder(); this.mode='space'; this.token=''; this.bytes=0; this.entries=0; this.escape=false; }
    emit(value, structural = false) {
        const top=this.stack.at(-1);
        if(structural && value==='{') {
            if(top.key===null || this.stack.length>32)throw new Error('Invalid schema nesting');
            const path=[...top.path,top.key], object=retain(path)?Object.create(null):null;
            if(object && top.object)top.object[top.key]=object;
            top.key=null;this.stack.push({path,object,key:null});
        } else if(structural && value==='}') {
            if(this.stack.length===1 || top.key!==null)throw new Error('Invalid schema object');this.stack.pop();
        } else if(top.key===null) {
            if(++this.entries>1000000)throw new Error('Item schema entry budget exceeded');top.key=value.toLowerCase();
        } else { if(top.object && retain([...top.path,top.key]))top.object[top.key]=value;top.key=null; }
    }
    text(text) {
        for(let i=0;i<text.length;i++) {
            const c=text[i];
            if(this.mode==='comment') {if(c==='\n')this.mode='space';continue;}
            if(this.mode==='slash') {if(c==='/'){this.mode='comment';continue;}this.mode='bare';this.token='/';}
            if(this.mode==='quote') {
                if(this.escape){this.token+=c==='"'?'"':'\\'+c;this.escape=false;}
                else if(c==='\\')this.escape=true;
                else if(c==='"'){this.emit(this.token);this.token='';this.mode='space';}
                else this.token+=c;
            } else {
                if(this.mode==='bare') {
                    if(!/\s|[{}]/.test(c)){this.token+=c;if(this.token.length>8192)throw new Error('Item schema token budget exceeded');continue;}
                    this.emit(this.token);this.token='';this.mode='space';
                }
                if(/\s/.test(c))continue;
                if(c==='{'||c==='}')this.emit(c,true);
                else if(c==='"')this.mode='quote';
                else if(c==='/')this.mode='slash';
                else {this.mode='bare';this.token=c;}
            }
            if(this.token.length>8192)throw new Error('Item schema token budget exceeded');
        }
    }
    push(bytes) { this.bytes+=bytes.byteLength;if(this.bytes>16*1024*1024)throw new Error('Item schema byte budget exceeded');this.text(this.decoder.decode(bytes,{stream:true})); }
    finish() {
        this.text(this.decoder.decode());if(this.mode==='bare')this.emit(this.token);
        if(this.stack.length!==1 || this.stack[0].key!==null || !['space','comment','bare'].includes(this.mode))throw new Error('Incomplete item schema');
        return this.root.items_game;
    }
}
